



























































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'iconBtn'
})
export default class extends Vue {
  @Prop({ default: false }) private showEdit!: boolean;
  @Prop({ default: false }) private showDelete!: boolean;
  @Prop({ default: false }) private showDownload!: boolean;
  @Prop({ default: false }) private showSetSuperior!: boolean;
  @Prop({ default: false }) private showViewSubordinate!: boolean;

  public handleSetSuperior() {
    this.$emit('setSuperior');
  }
  public handleViewSubordinate() {
    this.$emit('viewSubordinate');
  }

  public handleEdit() {
    this.$emit('edit');
  }
  public handleDelete() {
    this.$emit('delete');
  }
  public handleDownload() {
    this.$emit('download');
  }
}
